(function(){
"use strict";

var SUPABASE_URL="https://ycentdpkspjdrzijrbsl.supabase.co";
var SUPABASE_KEY="sb_publishable_TgKotXn3vvPpdnad_wXc9g_X1DY7arT";
var STORAGE_KEY="sb-ycentdpkspjdrzijrbsl-auth-token";
var ALLOWED=["/dashboard","/sell-editor","/orders","/products","/group","/qr","/poster"];
var DEFAULT_ORDER=["/dashboard","/sell-editor","/orders","/products","/group","/qr","/poster"];
var state={visits:{},pinned:[],recency:{}};
var client=null;
var uid=null;
var syncTimer=null;
var lastRoute=null;
var arranging=false;

function getClient(){
  if(client)return client;
  if(!window.supabase||!window.supabase.createClient)return null;
  client=window.supabase.createClient(SUPABASE_URL,SUPABASE_KEY,{
    auth:{persistSession:true,autoRefreshToken:false,detectSessionInUrl:false,storageKey:STORAGE_KEY}
  });
  return client;
}
function normalizeRoute(route){
  route=String(route||"").split("?")[0];
  if(route.charAt(0)==="#")route=route.slice(1);
  if(route==="sales"||route==="/sales")return "/sell-editor";
  if(route.charAt(0)!=="/")route="/"+route;
  return ALLOWED.indexOf(route)!==-1?route:null;
}
function currentRoute(){
  return normalizeRoute(location.hash||"");
}
function routeFromLink(link){
  if(!link)return null;
  var raw=link.getAttribute("href")||"";
  var hash=raw.indexOf("#")>=0?raw.slice(raw.indexOf("#")):raw;
  return normalizeRoute(hash);
}
function safeObj(v){return v&&typeof v==="object"&&!Array.isArray(v)?v:{};}
function cleanState(input){
  input=input||{};
  var out={visits:{},pinned:[],recency:{}};
  var visits=safeObj(input.visits),recency=safeObj(input.recency);
  ALLOWED.forEach(function(r){
    var n=Number(visits[r]||0);
    if(Number.isFinite(n)&&n>0)out.visits[r]=Math.min(Math.floor(n),99999);
    var t=Number(recency[r]||0);
    if(Number.isFinite(t)&&t>0)out.recency[r]=Math.floor(t);
  });
  var seen={};
  (Array.isArray(input.pinned)?input.pinned:[]).forEach(function(r){
    r=normalizeRoute(r);
    if(r&&!seen[r]){seen[r]=true;out.pinned.push(r);}
  });
  return out;
}
function userIdFromStorage(){
  try{
    var raw=localStorage.getItem(STORAGE_KEY);
    if(!raw)return null;
    var parsed=JSON.parse(raw);
    var token=null;
    if(parsed&&parsed.user&&parsed.user.id)return parsed.user.id;
    if(parsed&&parsed.currentSession&&parsed.currentSession.user&&parsed.currentSession.user.id)return parsed.currentSession.user.id;
    if(Array.isArray(parsed)&&parsed[0])token=parsed[0];
    if(parsed&&parsed.access_token)token=parsed.access_token;
    if(!token)return null;
    var body=JSON.parse(atob(token.split(".")[1].replace(/-/g,"+").replace(/_/g,"/")));
    return body&&body.sub?body.sub:null;
  }catch(e){return null;}
}
function localKey(){return uid?"kp-adaptive-nav-v1:"+uid:null;}
function loadLocal(){
  var key=localKey();if(!key)return;
  try{
    var raw=localStorage.getItem(key);
    if(raw)state=cleanState(JSON.parse(raw));
  }catch(e){}
}
function saveLocal(){
  var key=localKey();if(!key)return;
  try{localStorage.setItem(key,JSON.stringify(state));}catch(e){}
}
function score(route){
  return Number(state.visits[route]||0);
}
function pinIndex(route){
  return state.pinned.indexOf(route);
}
function compareRoutes(a,b){
  var ap=pinIndex(a),bp=pinIndex(b);
  if(ap!==-1||bp!==-1){
    if(ap===-1)return 1;
    if(bp===-1)return -1;
    return ap-bp;
  }
  var av=score(a),bv=score(b);
  if(av!==bv)return bv-av;
  var ar=Number(state.recency[a]||0),br=Number(state.recency[b]||0);
  if(ar!==br)return br-ar;
  return DEFAULT_ORDER.indexOf(a)-DEFAULT_ORDER.indexOf(b);
}
function orderedRoutes(){
  return ALLOWED.slice().sort(compareRoutes);
}
function pinSvg(pinned){
  return pinned
    ? '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M14.8 3.2a1 1 0 0 1 1.4 0l4.6 4.6a1 1 0 0 1 0 1.4l-2 2-2.5-.5-4.5 4.5.6 2.8-1.5 1.5-3.2-3.2-3.8 3.8-1.4-1.4 3.8-3.8-3.2-3.2 1.5-1.5 2.8.6 4.5-4.5-.5-2.5 2-2Z"/></svg>'
    : '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="m14.8 3.2 6 6-2 2-2.5-.5-4.5 4.5.6 2.8-1.5 1.5-6.3-6.3 1.5-1.5 2.8.6 4.5-4.5-.5-2.5 1.9-2Z"/><path d="m7.7 16.3-3.8 3.8"/></svg>';
}
function ensureZone(side){
  var zone=side.querySelector(":scope > .kp-smart-nav-zone");
  if(zone)return zone;
  zone=document.createElement("div");
  zone.className="kp-smart-nav-zone";
  var hint=document.createElement("div");
  hint.className="kp-smart-nav-hint";
  hint.innerHTML='<span><b>Personlig meny</b> · mest använda först</span><span>Fäst med nålen</span>';
  zone.appendChild(hint);
  var firstItem=side.querySelector(":scope > .nav-item, :scope > .kp-smart-nav-row");
  var firstLabel=side.querySelector(":scope > .nav-group-label");
  if(firstLabel&&firstLabel.nextSibling)side.insertBefore(zone,firstLabel.nextSibling);
  else if(firstItem)side.insertBefore(zone,firstItem);
  else side.appendChild(zone);
  return zone;
}
function wrapLink(link,zone){
  var route=routeFromLink(link);if(!route)return null;
  var row=link.closest(".kp-smart-nav-row");
  if(!row){
    row=document.createElement("div");
    row.className="kp-smart-nav-row";
    link.parentNode.insertBefore(row,link);
    row.appendChild(link);
  }
  row.dataset.kpRoute=route;
  var pin=row.querySelector(".kp-nav-pin");
  if(!pin){
    pin=document.createElement("button");
    pin.type="button";
    pin.className="kp-nav-pin";
    row.appendChild(pin);
    pin.addEventListener("click",function(e){
      e.preventDefault();
      e.stopPropagation();
      togglePin(route);
    });
  }
  updatePin(row,route);
  if(row.parentNode!==zone)zone.appendChild(row);
  return row;
}
function updatePin(row,route){
  var pin=row.querySelector(".kp-nav-pin");if(!pin)return;
  var pinned=pinIndex(route)!==-1;
  var flag=pinned?"1":"0";
  row.classList.toggle("is-pinned",pinned);
  pin.classList.toggle("is-pinned",pinned);
  if(pin.dataset.kpPinned!==flag){
    pin.dataset.kpPinned=flag;
    pin.innerHTML=pinSvg(pinned);
  }
  pin.setAttribute("aria-label",pinned?"Lossa från toppen":"Fäst högst upp");
  pin.title=pinned?"Lossa från toppen":"Fäst högst upp";
}
function animateOrder(zone,rowsByRoute,routes){
  var current=[].slice.call(zone.querySelectorAll(":scope > .kp-smart-nav-row")).map(function(row){
    return row.dataset.kpRoute;
  });
  var desired=routes.slice();
  var same=current.length===desired.length&&current.every(function(r,i){return r===desired[i];});
  if(same)return;

  var before={};
  routes.forEach(function(r){
    var row=rowsByRoute[r];
    if(row)before[r]=row.getBoundingClientRect();
  });
  routes.forEach(function(r){
    var row=rowsByRoute[r];
    if(row&&row!==zone.lastElementChild)zone.appendChild(row);
    else if(row&&row.parentNode!==zone)zone.appendChild(row);
  });
  routes.forEach(function(r){
    var row=rowsByRoute[r],a=before[r];
    if(!row||!a)return;
    var b=row.getBoundingClientRect();
    var dy=a.top-b.top;
    if(Math.abs(dy)>1&&row.animate){
      row.animate(
        [{transform:"translateY("+dy+"px)"},{transform:"translateY(0)"}],
        {duration:260,easing:"cubic-bezier(.22,1,.36,1)"}
      );
    }
  });
}
function arrange(){
  if(arranging)return;
  var side=document.querySelector(".side-nav");
  if(!side)return;
  arranging=true;
  try{
    var zone=ensureZone(side);
    var links=[].slice.call(side.querySelectorAll("a.nav-item[href]")).filter(function(link){
      return !!routeFromLink(link);
    });
    var rows={};
    links.forEach(function(link){
      var row=wrapLink(link,zone);
      if(row)rows[row.dataset.kpRoute]=row;
    });
    var routes=orderedRoutes().filter(function(r){return !!rows[r];});
    animateOrder(zone,rows,routes);
    Object.keys(rows).forEach(function(r){updatePin(rows[r],r);});
  }finally{
    arranging=false;
  }
}
function togglePin(route){
  route=normalizeRoute(route);if(!route)return;
  var i=state.pinned.indexOf(route);
  if(i===-1)state.pinned.push(route);
  else state.pinned.splice(i,1);
  saveLocal();
  arrange();
  scheduleServerSave();
}
function recordVisit(){
  var r=currentRoute();
  if(!r||r===lastRoute)return;
  lastRoute=r;
  state.visits[r]=Math.min(Number(state.visits[r]||0)+1,99999);
  state.recency[r]=Date.now();
  saveLocal();
  arrange();
  scheduleServerSave();
}
function scheduleServerSave(){
  if(syncTimer)clearTimeout(syncTimer);
  syncTimer=setTimeout(saveServer,900);
}
async function saveServer(){
  var sb=getClient();if(!sb||!uid)return;
  try{
    await sb.rpc("save_my_nav_preferences_v1",{
      p_visits:state.visits,
      p_pinned:state.pinned,
      p_recency:state.recency
    });
  }catch(e){}
}
async function hydrate(){
  uid=userIdFromStorage();
  var sb=getClient();
  if(!uid&&sb){
    try{
      var u=await sb.auth.getUser();
      if(u&&u.data&&u.data.user)uid=u.data.user.id;
    }catch(e){}
  }
  loadLocal();
  arrange();
  if(!sb||!uid)return;
  try{
    var res=await sb.rpc("get_my_nav_preferences_v1");
    if(!res.error&&res.data){
      var server=cleanState(res.data);
      var serverHas=Object.keys(server.visits).length||server.pinned.length||Object.keys(server.recency).length;
      if(serverHas){
        state=server;
        saveLocal();
        arrange();
      }else{
        scheduleServerSave();
      }
    }
  }catch(e){}
}

var pending=false;
function scheduleArrange(){
  if(pending)return;
  pending=true;
  requestAnimationFrame(function(){
    pending=false;
    arrange();
  });
}

window.addEventListener("hashchange",function(){
  setTimeout(function(){
    recordVisit();
    arrange();
  },120);
});

var app=document.getElementById("app");
if(app&&window.MutationObserver){
  new MutationObserver(scheduleArrange).observe(app,{childList:true});
}

setTimeout(function(){
  hydrate().then(function(){
    recordVisit();
    arrange();
  });
},500);
})();